import React, { useEffect, useState } from "react"
import styles from "./apiIntegration.module.css"
import Button from "../../components/Form/Button"
import Table from "../../components/Table"
import FormGroup from "../../components/Form/FormGroup"
import BreakForm from "../../components/Form/BreakForm"
import FormGroupInline from "../../components/Form/FormGroupInline"
import ModalApiToken from "../../components/Modal/ModalApiToken"
import api from '../../services/api'
import { toast } from 'react-toastify'
import moment from "moment"
import ModalDelete from "../../components/Modal/ModalDelete"
import { MdOutlineDeleteOutline } from "react-icons/md"
import Loading from "../layouts/Loading"
import BackButton from "../../components/BackButton"
import { useParams } from "react-router-dom"
import { getApiTokenAccessLabel, getApiTokenExpirationDate } from "../../utils/apiTokens"

const headersToken = [
    "#",
    "Identificação",
    "Ambiente",
    "Acesso",
    "Token",
    "Expira em",
    "Status",
    "",
]

const ApiToken = () => {
    const [tokens, setTokens] = useState([])
    const [environments, setEnvironments] = useState(["live"])
    const [showModalToken, setShowModalToken] = useState(false)
    const [showNewToken, setShowNewToken] = useState(false)
    const [newToken, setNewToken] = useState("")
    const [tokenEdit, setTokenEdit] = useState()
    const [showModalDelete, setShowModalDelete] = useState(false)
    const [tokenIdDelete, setTokenIdDelete] = useState()
    const [loading, setLoading] = useState(0)
    const { account_id } = useParams()

    useEffect(() => {
        getAllTokens()
    }, [])

    const getAllTokens = async () => {
        try {
            setLoading(previousValue => ++previousValue)
            const response = await api.get("/integrations/api/tokens")
            const tokenList = response?.data?.data
            const environmentList = response?.data?.environments
            setTokens(Array.isArray(tokenList) ? tokenList.filter(Boolean) : [])
            setEnvironments(Array.isArray(environmentList) && environmentList.length ? environmentList : ["live"])
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const getFilteredValuesToken = () => {
        const values = Array.isArray(tokens) ? [...tokens] : []
        values.sort((a, b) => {
            if (a.name > b.name) {
                return 1
            } else if (a.name < b.name) {
                return - 1
            } else {
                return 0
            }
        })
        const filteredValues = values?.map((token) => getDataNewToken(token)).filter(Boolean)
        return filteredValues
    }

    const getDataNewToken = (newToken) => {
        if (!newToken || typeof newToken !== "object") return null
        const environment = newToken.environment || "live"
        const accessClass = newToken.access_mode === "read_only" ? "readOnly" : newToken.access_mode === "custom" ? "customAccess" : "readWrite"
        const accessLabel = `${getApiTokenAccessLabel(newToken.access_mode)}${newToken.access_mode === "custom" ? ` (${newToken.scopes?.length || 0})` : ""}`
        const expirationDate = newToken.expires ? getApiTokenExpirationDate(newToken.expires_at) : null
        const expirationLabel = !newToken.expires ? "Nunca" : expirationDate ? moment(expirationDate).format("DD/MM/YYYY") : "Data inválida"
        const statusLabel = !newToken.expires ? "Ativo" : !expirationDate ? "Inválido" : expirationDate.getTime() >= Date.now() ? "Ativo" : "Expirado"
        const data = {
            id: `${environment}:${newToken._id}`,
            value: [
                newToken.name,
                <span className={`${styles.tokenEnvironment} ${styles[environment]}`}>{environment === "sandbox" ? "Sandbox" : "Produção"}</span>,
                <span className={`${styles.tokenAccess} ${styles[accessClass]}`}>{accessLabel}</span>,
                newToken.token,
                expirationLabel,
                statusLabel,
            ],
            actions: [
                {
                    label: "Editar",
                    onClick: handleOpenModalEdit,
                },
                {
                    label: "Excluir",
                    onClick: handleOpenModalDelete
                }
            ]
        }
        return data
    }

    const handleShowModalToken = () => {
        setTokenEdit()
        setShowModalToken(true)
    }

    const handleCloseModalToken = () => {
        setShowModalToken(false)
        setShowNewToken(false)
        setNewToken("")
        setTokenEdit()
    }

    const handleSaveNewToken = async (e, data) => {
        try {
            setLoading(previousValue => ++previousValue)
            e.preventDefault()
            if (tokenEdit) {
                const environment = tokenEdit.environment || "live"
                const response = await api.patch(`/integrations/api/tokens/${tokenEdit._id}`, {
                    name: data.name,
                    access_mode: data.access_mode,
                    scopes: data.scopes,
                    expire_in: data.expire_in,
                }, { params: { environment } })
                const updatedToken = response?.data?.data
                if (updatedToken) {
                    setTokens(previousValue => previousValue.map(token => (
                        token._id === updatedToken._id && (token.environment || "live") === environment
                            ? updatedToken
                            : token
                    )))
                }
                handleCloseModalToken()
                toast.success(response?.data?.message)
                return
            }
            const response = await api.post("/integrations/api/tokens", data)
            const newToken = response?.data?.data
            if (newToken) {
                setTokens(previousValue => {
                    const tokenExists = previousValue.some(token => token._id === newToken._id)
                    if (!tokenExists) {
                        return [...previousValue, newToken]
                    }
                    return previousValue
                })
                setNewToken(newToken.fullToken)
                setShowNewToken(true)
            }
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const handleOpenModalEdit = (tokenKey) => {
        const [environment, token_id] = String(tokenKey).split(":")
        const token = tokens.find(item => item._id === token_id && (item.environment || "live") === environment)
        if (!token) return
        setTokenEdit(token)
        setShowNewToken(false)
        setShowModalToken(true)
    }

    const handleDeleteToken = async (tokenKey) => {
        try {
            setLoading(previousValue => ++previousValue)
            const [environment, token_id] = String(tokenKey).split(":")
            const response = await api.delete(`/integrations/api/tokens/${token_id}`, { params: { environment } })
            setTokens(previousValue => previousValue?.filter(token => !(token._id === token_id && (token.environment || "live") === environment)))
            handleCloseModalDelete()
            toast.success(response?.data?.message)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(previousValue => Math.max(0, previousValue - 1))
        }
    }

    const handleOpenModalDelete = (token_id) => {
        setTokenIdDelete(token_id)
        setShowModalDelete(true)
    }

    const handleCloseModalDelete = () => {
        setTokenIdDelete()
        setShowModalDelete(false)
    }

    return (
        <>
            <div className={styles.container}>
                <div className="page-back-row">
                    <BackButton fallback={`/${account_id}/integrations/api`} />
                </div>
                <FormGroup>
                    <FormGroupInline>
                        <div className={styles.header}>
                            <BreakForm title="Tokens" showAction={false} />
                            <span>Os tokens são utilizados para autenticar suas requisições em nossa API. Guarde eles em segurança, e não os compartilhe com ninguém.</span>
                        </div>
                        <Button variant="primary" onClick={handleShowModalToken}>Novo token</Button>
                    </FormGroupInline>
                    <Table
                        headers={headersToken}
                        values={getFilteredValuesToken()}
                        messageNotRegisters="Nenhum registro encontrado"
                        showIndex={true}
                    />
                </FormGroup>
            </div>
            {showModalToken &&
                <ModalApiToken
                    onSubmit={handleSaveNewToken}
                    closeModal={handleCloseModalToken}
                    newToken={newToken}
                    showNewToken={showNewToken}
                    environments={environments}
                    editing={Boolean(tokenEdit)}
                    value={tokenEdit}
                />
            }
            {showModalDelete &&
                <ModalDelete
                    closeModal={handleCloseModalDelete}
                    onSubmit={handleDeleteToken}
                    icon={<MdOutlineDeleteOutline />}
                    title="Exclusão de token"
                    description="Deseja realmente excluir o token?"
                    id={tokenIdDelete}
                />
            }
            {loading > 0 && <Loading fullPage={true} />}
        </>
    )
}

export default ApiToken
